import React from "react";
import { useHistory } from "react-router-dom";
import { Grid, Typography, Paper, makeStyles } from "@material-ui/core";
import PageHeader from "../../components/PageHeader";
import ProgramCardBg from "../../resources/programs_card_bg.jpg";
import SupersetsCardBg from "../../resources/supersets_card_bg.jpg";
import ExerciseCardBg from "../../resources/exercise_card_bg.jpg";
import WorkoutCardBg from "../../resources/workout_card_bg.jpg";
import ChevronRightIcon from "@material-ui/icons/ChevronRight";
import { colors } from "../../styles";

const useStyles = makeStyles({
  container: {
    padding: 20,
    display: "flex",
    justifyContent: "center",
    flexWrap: "wrap",
    maxWidth: 1200,
    margin: "0 auto",
    marginTop: 30,
  },
  tile: {
    position: "relative",
    height: 220,
    width: "100%", // This allows responsiveness with Grid
    maxWidth: 560,

    backgroundSize: "cover",
    backgroundPosition: "center",
    borderRadius: 17,
    cursor: "pointer",
    overflow: "hidden",
    color: colors.white,
    display: "flex",
    alignItems: "flex-end",

    transition: "transform 0.3s ease",
    "&:hover": {
      transform: "translateY(-4px)",
    },
  },
  overlay: {
    background: colors.cardOverlay,
    padding: 35,
    width: "100%",
    height: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
  },
  chevron: {
    fontSize: "32px",
    marginLeft: "auto",
    color: colors.white,
  },
  title: {
    fontFamily: "Archivo-Bold, sans-serif",
    fontWeight: 700,
    fontSize: 32,
    lineHeight: 33,
    letterSpacing: "0px",
    verticalAlign: "middle",
    alignSelf: "center",
    color: colors.white,
  },
});

const tileData = [
  {
    label: "Exercises",
    path: "/libraries/exercises",
    image: ExerciseCardBg,
  },
  {
    label: "Workouts",
    path: "/libraries/workouts",
    image: WorkoutCardBg,
  },
  {
    label: "Supersets & Circuits",
    path: "/libraries/sets",
    image: SupersetsCardBg,
  },
  {
    label: "Programs",
    path: "/libraries/programs",
    image: ProgramCardBg,
  },
];

function LibrariesHome() {
  const classes = useStyles();
  const history = useHistory();

  return (
    <>
      <PageHeader title="Libraries" containerStyle={{ paddingBottom: 20 }} />
      <div className={classes.container}>
        <Grid container spacing={4}>
          {tileData.map((tile, index) => (
            <Grid item xs={12} sm={6} md={6} key={index}>
              <Paper
                className={classes.tile}
                style={{ backgroundImage: `url(${tile.image})` }}
                onClick={() => history.push(tile.path)}
                elevation={4}
              >
                <div className={classes.overlay}>
                  <Typography className={classes.title}>
                    {tile.label}
                  </Typography>
                  <ChevronRightIcon className={classes.chevron} />
                </div>
              </Paper>
            </Grid>
          ))}
        </Grid>
      </div>
    </>
  );
}

export default LibrariesHome;
